import { paymentOrderConstants } from '../actions/constants';

const initialState = {
    loading: false,
    url: '',
    error: null,
};

const paymentOrder = (state = initialState, action) => {
    switch (action.type) {
        case paymentOrderConstants.INIT_PAYMENT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case paymentOrderConstants.INIT_PAYMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                url: action.payload.url,
            };
        case paymentOrderConstants.INIT_PAYMENT_FAILURE:
            return {  
                ...state,
                loading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};

export default paymentOrder;
